import { DateTime } from 'luxon';
import { usePageExperienceContext } from '@/features/experiences/contexts/PageExperienceContext';
import { Text } from '@/ui';

export const TimezoneLabel = () => {
  const { displayTimezone } = usePageExperienceContext();
  const tzAbbr = DateTime.local({ zone: displayTimezone }).toFormat('ZZZZ');

  return (
    <Text
      color="ink.muted"
      fontSize="ah-status"
      fontWeight={500}
      whiteSpace="nowrap"
    >
      Times in {tzAbbr}
    </Text>
  );
};
